// Module
var code = `<!-- Blog article shell — header renders from article meta; bl* content
     blocks append into .blog-blocks (see PageBlogArticleView).
     The back link routes through CHANNEL_UI (the view broadcasts
     'a:not(.external)' clicks); data-section="" clears the article
     segment so PageBlog renders the card list. -->
<div class="blog-back-holder">
    <a class="blog-back-link"
       href="/blog"
       data-channel="ROUTE"
       data-event-prevent-default="true"
       data-page-id="blog"
       data-section=""
       aria-label="Back to all articles"><svg class="blog-back-link__arrow"
            aria-hidden="true"
            focusable="false"
            viewBox="0 0 128 128"
            xmlns="http://www.w3.org/2000/svg"><path d="m80.195 111.8 6.9961-6.9961-40.867-40.809 40.867-40.809-6.9961-6.9961-47.75 47.805z"/></svg>Back</a>
</div>

<article class="blog">
    <h1 class="blog-heading" id="{{titleId}}">{{title}}</h1>
    <h2 class="subtitle">{{subtitle}}</h2>

    <div class="meta">
        <img src="{{authorImg}}" alt="{{author}}">
        <div class="meta-info">
            <a href="{{authorHref}}" class="meta-name">{{author}}</a>
            <span class="meta-date">{{date}} · {{readTime}}</span>
        </div>
    </div>

    <div class="blog-blocks"></div>
</article>
`;
// Exports
module.exports = code;